import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Popover/popover';
import { css } from '@patternfly/react-styles';
export const PopoverArrow = (_a) => {
    var { className = '' } = _a, props = __rest(_a, ["className"]);
    return React.createElement("div", Object.assign({ className: css(styles.popoverArrow, className) }, props));
};
PopoverArrow.displayName = 'PopoverArrow';
//# sourceMappingURL=PopoverArrow.js.map